import React from "react";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

/** Build a URL to the auth-gated /api/files endpoint. Browser cookies auto-attach. */
export function photoUrl(photo) {
  if (!photo) return null;
  const p = photo.storage_path || photo.path || (typeof photo === "string" ? photo : null);
  if (!p) return null;
  return `${API_BASE}/api/files/${p}`;
}

/** Pure-text monogram fallback (used when no photo exists) */
export function Monogram({ name, className = "", size = "text-2xl" }) {
  const initials = (name || "?")
    .split(" ")
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return (
    <div
      className={`flex items-center justify-center bg-gradient-to-br from-brand-bone to-brand-line ${className}`}
      data-testid="monogram-fallback"
    >
      <span className={`font-serif text-brand-terracotta num-lining ${size}`}>{initials}</span>
    </div>
  );
}

/** Renders a profile's primary photo, falling back to a monogram. */
export function ProfilePhoto({ profile, className = "", size = "text-2xl" }) {
  const url = photoUrl(profile?.primary_photo);
  const [failed, setFailed] = React.useState(false);
  if (!url || failed) {
    return <Monogram name={profile?.name} className={className} size={size} />;
  }
  return (
    <img
      src={url}
      alt={profile?.name || "Profile"}
      onError={() => setFailed(true)}
      className={`object-cover ${className}`}
      data-testid={`profile-photo-${profile?.id || "unknown"}`}
      loading="lazy"
    />
  );
}

/**
 * Kept for backward compat. Prefer <ProfilePhoto profile={...} /> for automatic
 * photo/monogram fallback. If a `photo` object (with storage_path) is passed
 * directly, it will be rendered.
 */
export function AuthImage({ alt, className, photo }) {
  const url = photoUrl(photo);
  const [failed, setFailed] = React.useState(false);
  if (!url || failed) {
    return <Monogram name={alt} className={className} />;
  }
  return (
    <img
      src={url}
      alt={alt || "Image"}
      onError={() => setFailed(true)}
      className={`object-cover ${className}`}
      loading="lazy"
    />
  );
}
